import jQuery from 'jquery';
import '@js/vendor/slick.min.js';
jQuery(function($) {


    // Construkt Gallery Block Type 1 - Inline Gallery Slider

    if ($('.c-slider-gallery').length) {

        $('.c-slider-gallery').slick({
            dots: false,
            infinite: false,
            speed: 300,
            variableWidth: true,
            adaptiveHeight: true,
            arrowsPlacement: 'afterSlides',
            getCaptionFromTitleOrAlt: false,
        });

    }

    // Construkt Gallery Block Type 2 - Two linked sliders, one main with secondary thumbnail controls

    if ($('.c-col-gallery-main-slider').length) {

        const $galleryBlockMainSliderElements = $('.c-col-gallery-main-slider');
        const $galleryBlockThumbControlsElements = $('.c-col-gallery-slider-thumbs');

        $galleryBlockMainSliderElements.each( function(index, gallery) {


            let $associatedThumbs = $galleryBlockThumbControlsElements[index];

            $(gallery).slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true,
                asNavFor: $associatedThumbs,
                getCaptionFromTitleOrAlt: false,
            })

        });

        $galleryBlockThumbControlsElements.each( function(index, thumbs) {

            let $associatedGallery = $galleryBlockMainSliderElements[index];

            $(thumbs).slick({
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 3,
                    }
                }],
                asNavFor: $associatedGallery,
                dots: false,
                focusOnSelect: true,
                getCaptionFromTitleOrAlt: false,
            });

            // On click of thumbnail itself, navigate to the respective index.
            $(thumbs).find('.slick-slide a').click(function(e) {
                e.preventDefault();
                $(thumbs).slick('slickGoTo', $(this).parent().parent().parent().index());
            });

        });

    }


    // Construkt Events Block Slider

     // Standard width option

     if ($('.c-col-events-block--standard.c-col-events-block--carousel').length) {

        $('.c-col-events-block--standard.c-col-events-block--carousel .c-event-grid-items').slick({
            dots: false,
            infinite: false,
            speed: 300,
            arrowsPlacement: 'afterSlides',
            slidesToShow: 3.1,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.2,
                }
            }],
        });

    }

    // Large width option

    if ($('.c-col-events-block--large.c-col-events-block--carousel').length) {

        $('.c-col-events-block--large.c-col-events-block--carousel .c-event-grid-items').slick({
            dots: false,
            infinite: false,
            speed: 300,
            arrowsPlacement: 'afterSlides',
            slidesToShow: 2.05,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.05,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.05,
                }
            }],
        });

    }

    // Construkt News Block Slider

     // Standard width option

     if ($('.c-col-news-block--standard.c-col-news-block--carousel').length) {

        $('.c-col-news-block--standard.c-col-news-block--carousel .c-news-block__items').slick({
            dots: false,
            infinite: false,
            speed: 300,
            arrowsPlacement: 'afterSlides',
            slidesToShow: 3.1,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.2,
                }
            }],
        });

    }

    // Large width option

    if ($('.c-col-news-block--large.c-col-news-block--carousel').length) {

        $('.c-col-news-block--large.c-col-news-block--carousel .c-news-block__items').slick({
            dots: false,
            infinite: false,
            speed: 300,
            arrowsPlacement: 'afterSlides',
            slidesToShow: 2.05,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.05,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.05,
                }
            }],
        });

    }

    // Classes used in activities blocks, related events and related magazine posts 
    // Rather than toggled by a field, this automatically kicks in when space dictates

    if ($('.c-carousel-block').length) {

        $('.c-carousel-block .c-carousel-block__items').slick({
            dots: false,
            infinite: false,
            speed: 300,
            arrowsPlacement: 'afterSlides',
            slidesToShow: 3.1,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.2,
                }
            }],
        });

    }


    if ($('.c-col-biographies--carousel').length) {

        $('.c-col-biographies--carousel .c-col-bios-grid').slick({
            dots: false,
            infinite: false,
            speed: 300,
            arrowsPlacement: 'afterSlides',
            slidesToShow: 4,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                }
            }],
        });

    }

    // Construkt Card Block - Multiple Image Slider

    if ($('.c-col-card__image-slider').length) {

        $('.c-col-card__image-slider').slick({
            speed: 400,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrowsPlacement: 'afterSlides',
        });

    }

    // Venue Block Image Slider

    if ($('.c-location-block__image--carousel').length) {

        $('.c-location-block__image--carousel').slick({
            speed: 400,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrowsPlacement: 'afterSlides',
        });

    }

    // Construkt Sponsor logo block slider

    if ($('.c-col-logos.c-col-logos--carousel').length) {

        $('.c-col-logos.c-col-logos--carousel .c-col-logos__items').slick({
            speed: 800,
            dots: false,
            arrows: true,
            slidesToShow: 4,
            infinite: false,
            responsive: [{
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            },{
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                }
            }],
            arrowsPlacement: 'afterSlides',
        });

    }

    // Construkt Quotes block slider

    if ($('.c-col-quotes.c-col-quotes--carousel').length) {

        $('.c-col-quotes.c-col-quotes--carousel .c-quotes-list').slick({
            speed: 800,
            dots: false,
            arrows: true,
            slidesToShow: 2,
            infinite: false,
            responsive: [{
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                }
                }],
            arrowsPlacement: 'afterSlides',
        });

    }


    // FOH Screen slider

    if ($('.c-foh-listings').length) {

        const $fohSlider = $('.c-foh-listings');
        const $fohSliderStatus = $('.c-foh-page__slide-label');

        $fohSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            let i = (currentSlide ? currentSlide : 0) + 1;
            $fohSliderStatus.text('Page ' + i + ' of ' + slick.slideCount);
        });

        $fohSlider.slick({
            speed: 400,
            dots: true,
            arrows: false,
            dots: false,
            fade: true,
            speed: 2000,
            infinite: true,
            cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
            autoplay: true,
            autoplaySpeed: 8000,
        });

    }

})
